<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a @click="processSetGoals" class="cursor-pointer text-900 white-space-nowrap">Plan</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Remove from Watchlist</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Remove stocks from your Watchlist.
                </span>
            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="field">
                        <span>Functionality not available with current subscription. Please upgrade to view functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="field">
                        <span>Future enhancement coming soon, will provide personalized planning functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 3" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <DataTable
                        :value="watchList"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        responsiveLayout="scroll">

                        <template #empty>
                            No watchlist items found.
                        </template>

                        <template #loading>
                            Loading watchlist items. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1"
                                        :loading="submitted" @click="callDeleteWatchlistItem(data)"/>
                            </template>
                        </Column>

                        <Column field="exchange" header="Exchange" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Exchange</span>
                                {{ data.exchange }}
                            </template>
                        </Column>

                        <Column field="code" header="Stock Symbol" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Stock Symbol</span>
                                {{ data.code }}
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Watchlist Item for {{ this.existingWatchlistItem.code }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Item?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteWatchlistItem"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callOverviewWatchList"></Button>

                </div>
            </div>
        </div>

    </div>


    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import StockDataService from "@/service/StockDataService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import numeral from "numeral";
import StockHistoryService from "@/service/StockHistoryService";
import StockService from "@/service/StockService";
import WatchlistService from "@/service/WatchlistService";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();
    },
    async mounted() {
        this.loading = true;

        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            const pingData = await UserService.getUserPing();
            console.log("[Applications][mounted] System is active.");
            console.log("[Applications][mounted] Data = ", pingData);
        } catch (e) {
            console.log("[Applications][mounted] System is NOT active.");
            console.log("[Applications][mounted] Error = ", e);

            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        if (this.userStore.user === undefined) {
            console.log("[Applications][mounted] User is NOT defined.");

            this.userStore.clearUser();
            // this.$router.push('login');
            this.$router.replace('/siLogin');
        } else {
            console.log("[Applications][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
                console.log("[Applications][mounted] Data = ", userData);

                if (this.profile.rights === 'C') {
                    this.activeTab = 1;
                } else {
                    this.activeTab = 3;
                }

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;
                    console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
                } catch (e) {
                    console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;

                }

                if (this.userConfiguration.enableSiUs === 'Y') {
                    var newEntry1 = {name: 'NYSE', code: 'NYSE'};
                    var newEntry2 = {name: 'NASDAQ', code: 'NASDAQ'};

                    var newCurrencyEntry1 = {name: 'USD', code: 'USD'};

                    this.exchanges.push(newEntry1);
                    this.exchanges.push(newEntry2);

                    this.currencyTypes.push(newCurrencyEntry1);
                }

                if (this.userConfiguration.enableSiCa === 'Y') {
                    var newEntry3 = {name: 'TSX', code: 'TO'};

                    var newCurrencyEntry2 = {name: 'CAD', code: 'CAD'};

                    this.exchanges.push(newEntry3);

                    this.currencyTypes.push(newCurrencyEntry2);
                }

                if (this.userConfiguration.enableSiUk === 'Y') {
                    var newEntry4 = {name: 'LSE', code: 'LSE'};

                    var newCurrencyEntry3 = {name: 'GBP', code: 'GBP'};

                    this.exchanges.push(newEntry4);

                    this.currencyTypes.push(newCurrencyEntry3);
                }

                if (this.userConfiguration.enableSiZa === 'Y') {
                    var newEntry5 = {name: 'JSE', code: 'JSE'};

                    var newCurrencyEntry4 = {name: 'ZAR', code: 'ZAR'};

                    this.exchanges.push(newEntry5);

                    this.currencyTypes.push(newCurrencyEntry4);
                }

                console.log("[Plan][mounted] this.exchanges = ", this.exchanges);

                if (this.exchanges.length > 0) {
                    this.selectedExchange = this.exchanges[0].code;
                }

                this.selectedColumns = this.columnConfig.filter(config =>
                    this.columnConfigCompact.some(compact => compact.field === config.field)
                );

                this.selectedFormat = "Compact";
                this.selectedStandardFilter = "topRanked";
                this.selectedTimePeriod = "20";

                console.log("[Plan][mounted] this.selectedExchange = ", this.selectedExchange);

                const promises = [
                    StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
                    WatchlistService.getUserWatchlists(this.userStore.user.id)
                ];

                // Run the promises but do not await them.
                promises.forEach((promise, index) => {
                    promise.then(result => {
                        // Handle the result here, e.g., assign to a data property
                        if (index === 0) {
                            this.stockData = result.data;
                            this.originalStockData = result.data;
                        } else if (index === 1) {
                            this.watchList = result.data;
                        }
                    }).catch(e => {
                        // Handle the error here
                        console.error("Error in promise", index, e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    });
                });

                this.loading = false;

            } catch (e) {
                console.log("[Applications][mounted] No user data found.");
                console.log("[Applications][mounted] Error = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            this.loading = false;
        }
    },
    data() {

        return {
            profile: {},
            userConfiguration: {},
            activeTab: 3,
            loading: false,
            submitted: false,
            exchanges: [],
            selectedExchange: "NYSE",
            selectedFormat: "Compact",
            selectedTimePeriod: "20",
            filters: null,
            stockData: [],
            stockHistory: [],
            specificStockData: {},
            specificStockDataArray: [],
            maxDividendYield: 0,
            lineData: [],
            lineOptions: [],
            selectedStockDataTimePeriod: "20",
            selectedStockDataStockHistoryOption: "DPS",
            searchCriteria: '',
            selectedWatchlistExchange: "NYSE",
            selectedWatchlistCode: '',
            filteredCodes: [],
            confirmationResponse: 'N',
            existingWatchlistItem: {},
            topRankedNyseCriteria: 10,
            topRankedLseCriteria: 6,
            topRankedJseCriteria: 6,
            runnersUpNyseCriteria: 9,
            runnersUpLseCriteria: 5,
            runnersUpJseCriteria: 5,
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            timePeriods: [
                {name: '20 Year', code: '20'},
                {name: '15 Year', code: '15'},
                {name: '10 Year', code: '10'},
                {name: '5 Year', code: '5'}
            ],
            timePeriodsGraph: [
                {name: '20 Year', code: '20'},
                {name: '15 Year', code: '15'},
                {name: '10 Year', code: '10'},
                {name: '5 Year', code: '5'},
                {name: 'Maximum', code: 'Maximum'},
            ],
            stockHistoryOptions: [
                {name: 'Dividends Per Share', code: 'DPS'},
                {name: 'Low Price', code: 'LSP'},
                {name: 'High Price', code: 'HSP'},
                {name: 'Average Price', code: 'ASP'},
                {name: 'EPS', code: 'EPS'}
            ],
            // currencyTypes: [
            //     {name: 'USD', code: 'USD'},
            //     {name: 'CAD', code: 'CAD'},
            //     {name: 'GBP', code: 'GBP'},
            //     {name: 'ZAR', code: 'ZAR'}
            // ],
            currencyTypes: [],
            formats: [
                {name: 'Minimal View', code: 'Compact'},
                {name: 'Extended View', code: 'Complete'}
            ],
            years: [
                {name: 2025, code: 2025},
                {name: 2026, code: 2026},
                {name: 2027, code: 2027},
                {name: 2028, code: 2028},
                {name: 2029, code: 2029},
                {name: 2030, code: 2030},
                {name: 2031, code: 2031},
                {name: 2032, code: 2032},
                {name: 2033, code: 2033},
                {name: 2034, code: 2034},
                {name: 2035, code: 2035},
                {name: 2036, code: 2036},
                {name: 2037, code: 2037},
                {name: 2038, code: 2038},
                {name: 2039, code: 2039},
                {name: 2040, code: 2040},
                {name: 2041, code: 2041},
                {name: 2042, code: 2042},
                {name: 2043, code: 2043},
                {name: 2044, code: 2044},
                {name: 2045, code: 2045},
                {name: 2046, code: 2046},
                {name: 2047, code: 2047},
                {name: 2048, code: 2048},
                {name: 2049, code: 2049},
                {name: 2050, code: 2050}
            ],
            watchList: [],
            // watchList: [
            //     {exchange: 'JSE', code: 'TRU'},
            //     {exchange: 'JSE', code: 'CLH'},
            //     {exchange: 'JSE', code: 'AME'}
            // ],
            selectedColumns: [],
            columnConfig: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear15Id127',
                    header: 'SI Criteria out of 10 (15yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear15Id127'),
                },
                {
                    field: 'siCriteriaYear10Id126',
                    header: 'SI Criteria out of 10 (10yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear10Id126'),
                },
                {
                    field: 'siCriteriaYear5Id125',
                    header: 'SI Criteria out of 10 (5yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear5Id125'),
                },
                {
                    field: 'averageEpsGrowthYear20Id018',
                    header: 'R5a – Avg EPS Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear20Id018'),
                },
                {
                    field: 'averageEpsGrowthYear15Id017',
                    header: 'R5a – Avg EPS Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear15Id017'),
                },
                {
                    field: 'averageEpsGrowthYear10Id016',
                    header: 'R5a – Avg EPS Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear10Id016'),
                },
                {
                    field: 'averageEpsGrowthYear5Id015',
                    header: 'R5a – Avg EPS Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear5Id015'),
                },
                {
                    field: 'epsIncreasesYear20Id097',
                    header: 'R5b – EPS Increases in 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear20Id097'),
                },
                {
                    field: 'epsIncreasesYear15Id096',
                    header: 'R5b – EPS Increases in 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear15Id096'),
                },
                {
                    field: 'epsIncreasesYear10Id095',
                    header: 'R5b – EPS Increases in 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear10Id095'),
                },
                {
                    field: 'epsIncreasesYear5Id094',
                    header: 'R5b – EPS Increases in 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear5Id094'),
                },
                {
                    field: 'adgYear20Id009',
                    header: 'R6 – Avg Div Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'adgYear20Id009'),
                },
                {
                    field: 'adgYear15Id008',
                    header: 'R6 – Avg Div Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'adgYear15Id008'),
                },
                {
                    field: 'adgYear10Id007',
                    header: 'R6 – Avg Div Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'adgYear10Id007'),
                },
                {
                    field: 'adgYear5Id006',
                    header: 'R6 – Avg Div Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'adgYear5Id006'),
                },
                {
                    field: 'payoutRatioId107',
                    header: 'R7 – Payout Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'payoutRatioId107'),
                },
                {
                    field: 'longtermDebtEquityRatioId084',
                    header: 'R8 - LT Debt/Equity',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtEquityRatioId084'),
                },
                {
                    field: 'afdPreviousId005',
                    header: 'R9 - Fwd Dividend vs Prev Year',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'afdPreviousId005'),
                },
                {
                    field: 'shareBuybackId122',
                    header: 'R10 – Share Buyback?',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-buyback',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'shareBuybackId122'),
                },
                {
                    field: 'peRatioId104',
                    header: 'R11a – P/E Ratio TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'peRatioId104'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear20Id135',
                    header: 'R11b – Under/Over Valued Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear20Id135'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear15Id134',
                    header: 'R11b – Under/Over Valued Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear15Id134'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear10Id133',
                    header: 'R11b – Under/Over Valued Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear10Id133'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear5Id132',
                    header: 'R11b – Under/Over Valued Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear5Id132'),
                },
                {
                    field: 'pbRatioId102',
                    header: 'R11c – P/B Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pbRatioId102'),
                },
                {
                    field: 'yearsDividendIncreasesId047',
                    header: 'Consecutive Yrs Div Increases',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'yearsDividendIncreasesId047'),
                },
                {
                    field: 'hspWeek52Id001',
                    header: '52wk High',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspWeek52Id001'),
                },
                {
                    field: 'lspWeek52Id002',
                    header: '52wk Low',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspWeek52Id002'),
                },
                {
                    field: 'altmanZscoreId003',
                    header: 'Altman Z-Score',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'altmanZscoreId003'),
                },
                {
                    field: 'afdId004',
                    header: 'Annual Fwd Dividend',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'afdId004'),
                },
                {
                    field: 'adyYear5Id010',
                    header: 'Avg Div Yld 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear5Id010'),
                },
                {
                    field: 'adyYear10Id011',
                    header: 'Avg Div Yld 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear10Id011'),
                },
                {
                    field: 'adyYear15Id012',
                    header: 'Avg Div Yld 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear15Id012'),
                },
                {
                    field: 'adyYear20Id013',
                    header: 'Avg Div Yld 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear20Id013'),
                },

                {
                    field: 'averageEpsYear3Id014',
                    header: 'Avg 3yr EPS',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageEpsYear3Id014'),
                },
                {
                    field: 'averageHdyYear5Id019',
                    header: 'Avg High Div Yld 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear5Id019'),
                },
                {
                    field: 'averageHdyYear10Id020',
                    header: 'Avg High Div Yld 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear10Id020'),
                },
                {
                    field: 'averageHdyYear15Id021',
                    header: 'Avg High Div Yld 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear15Id021'),
                },
                {
                    field: 'averageHdyYear20Id022',
                    header: 'Avg High Div Yld 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear20Id022'),
                },
                {
                    field: 'averageHighPeRatioYear5Id023',
                    header: 'Avg High P/E 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear5Id023'),
                },
                {
                    field: 'averageHighPeRatioYear10Id024',
                    header: 'Avg High P/E 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear10Id024'),
                },
                {
                    field: 'averageHighPeRatioYear15Id025',
                    header: 'Avg High P/E 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear15Id025'),
                },
                {
                    field: 'averageHighPeRatioYear20Id026',
                    header: 'Avg High P/E 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear20Id026'),
                },
                {
                    field: 'averageLdyYear5Id027',
                    header: 'Avg Low Div Yld 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear5Id027'),
                },
                {
                    field: 'averageLdyYear10Id028',
                    header: 'Avg Low Div Yld 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear10Id028'),
                },
                {
                    field: 'averageLdyYear15Id029',
                    header: 'Avg Low Div Yld 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear15Id029'),
                },
                {
                    field: 'averageLdyYear20Id030',
                    header: 'Avg Low Div Yld 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear20Id030'),
                },
                {
                    field: 'averageLowPeRatioYear5Id031',
                    header: 'Avg Low P/E 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear5Id031'),
                },
                {
                    field: 'averageLowPeRatioYear10Id032',
                    header: 'Avg Low P/E 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear10Id032'),
                },
                {
                    field: 'averageLowPeRatioYear15Id033',
                    header: 'Avg Low P/E 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear15Id033'),
                },
                {
                    field: 'averageLowPeRatioYear20Id034',
                    header: 'Avg Low P/E 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear20Id034'),
                },
                {
                    field: 'averagePeRatioYear5Id035',
                    header: 'Avg P/E 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear5Id035'),
                },
                {
                    field: 'averagePeRatioYear10Id036',
                    header: 'Avg P/E 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear10Id036'),
                },
                {
                    field: 'averagePeRatioYear15Id037',
                    header: 'Avg P/E 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear15Id037'),
                },
                {
                    field: 'averagePeRatioYear20Id038',
                    header: 'Avg P/E 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear20Id038'),
                },
                {
                    field: 'bookValuePerShareId039',
                    header: 'Bk Value/Share',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'bookValuePerShareId039'),
                },
                {
                    field: 'cashFlowPerShareId040',
                    header: 'Cashflow/Share',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'cashFlowPerShareId040'),
                },
                {
                    field: 'companyAddressCityId041',
                    header: 'City',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressCityId041'),
                },
                {
                    field: 'companyAddressCountryId042',
                    header: 'Country',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressCountryId042'),
                },
                {
                    field: 'companyAddressStateId043',
                    header: 'State/Prov',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressStateId043'),
                },
                {
                    field: 'companyAddressId044',
                    header: 'Address',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressId044'),
                },
                {
                    field: 'companyDescriptionId045',
                    header: 'Description',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyDescriptionId045'),
                },
                {
                    field: 'yearsEpsIncreasesId048',
                    header: 'Consecutive Yrs EPS Increases',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'yearsEpsIncreasesId048'),
                },
                {
                    field: 'currentAssetsId049',
                    header: 'Current Assets',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentAssetsId049'),
                },
                {
                    field: 'currentLiabilitiesId051',
                    header: 'Current Debt',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentLiabilitiesId051'),
                },
                {
                    field: 'currentRatioId052',
                    header: 'Current Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentRatioId052'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear5Id053',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear5Id053'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear10Id054',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear10Id054'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear15Id055',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear15Id055'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear20Id056',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear20Id056'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear5Id057',
                    header: 'Diff Between Current P/E & Avg P/E 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear5Id057'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear10Id058',
                    header: 'Diff Between Current P/E & Avg P/E 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear10Id058'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear15Id059',
                    header: 'Diff Between Current P/E & Avg P/E 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear15Id059'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear20Id060',
                    header: 'Diff Between Current P/E & Avg P/E 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear20Id060'),
                },

                {
                    field: 'dcfId061',
                    header: 'DCF',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dcfId061'),
                },
                {
                    field: 'dividendCurrencyId062',
                    header: 'Div Currency',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendCurrencyId062'),
                },
                {
                    field: 'dividendFrequencyId063',
                    header: 'Div Frequency',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendFrequencyId063'),
                },

                {
                    field: 'dgPlusDyYear5Id064',
                    header: 'Div Gr (5yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear5Id064'),
                },
                {
                    field: 'dgPlusDyYear10Id065',
                    header: 'Div Gr (10yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear10Id065'),
                },
                {
                    field: 'dgPlusDyYear15Id066',
                    header: 'Div Gr (15yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear15Id066'),
                },
                {
                    field: 'dgPlusDyYear20Id067',
                    header: 'Div Gr (20yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear20Id067'),
                },
                {
                    field: 'dividendPaymentDateId068',
                    header: 'Div Payment Date',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendPaymentDateId068'),
                },
                {
                    field: 'dividendRecordDateId069',
                    header: 'Div Record Date',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendRecordDateId069'),
                },
                {
                    field: 'dividendPaidId070',
                    header: 'Divs Paid Since',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendPaidId070'),
                },
                {
                    field: 'epsTtmId071',
                    header: 'EPS (TTM)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'epsTtmId071'),
                },
                {
                    field: 'esgScoreId072',
                    header: 'ESG Score',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'esgScoreId072'),
                },
                {
                    field: 'exchangeId073',
                    header: 'Exchange',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'exchangeId073'),
                },
                {
                    field: 'exDividendDateId074',
                    header: 'Ex-Div Date',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'exDividendDateId074'),
                },
                {
                    field: 'fiscalYearendDateId075',
                    header: 'Fiscal Yr End',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'fiscalYearendDateId075'),
                },
                {
                    field: 'grahamPriceId076',
                    header: 'Graham Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'grahamPriceId076'),
                },
                {
                    field: 'hspYear5Id077',
                    header: 'High Price Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear5Id077'),
                },
                {
                    field: 'hspYear10Id078',
                    header: 'High Price Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear10Id078'),
                },
                {
                    field: 'hspYear15Id079',
                    header: 'High Price Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear15Id079'),
                },
                {
                    field: 'hspYear20Id080',
                    header: 'High Price Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear20Id080'),
                },
                {
                    field: 'industryId081',
                    header: 'Industry',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'industryId081'),
                },
                {
                    field: 'longtermDebtId082',
                    header: 'LT Debt',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtId082'),
                },
                {
                    field: 'longtermDebtVsTotalCapitalId083',
                    header: 'LT Debt/Total Capital',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtVsTotalCapitalId083'),
                },
                {
                    field: 'lspYear5Id085',
                    header: 'Low Price Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear5Id085'),
                },
                {
                    field: 'lspYear10Id086',
                    header: 'Low Price Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear10Id086'),
                },
                {
                    field: 'lspYear15Id087',
                    header: 'Low Price Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear15Id087'),
                },
                {
                    field: 'lspYear20Id088',
                    header: 'Low Price Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear20Id088'),
                },
                {
                    field: 'marketId089',
                    header: 'Market/Country',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'marketId089'),
                },
                {
                    field: 'marketCapitalisationId090',
                    header: 'Market Cap',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'marketCapitalisationId090'),
                },
                {
                    field: 'netIncomeId091',
                    header: 'Net Income',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'netIncomeId091'),
                },
                {
                    field: 'netIncomePerShareId092',
                    header: 'Net Income/Share TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'netIncomePerShareId092'),
                },

                {
                    field: 'employeesId093',
                    header: 'Employees',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'employeesId093'),
                },
                {
                    field: 'outstandingSharesCurrentYearId098',
                    header: 'Share Outstanding',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'outstandingSharesCurrentYearId098'),
                },
                {
                    field: 'outstandingSharesPreviousYearId099',
                    header: 'Share Outstanding (previous Yr)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'outstandingSharesPreviousYearId099'),
                },
                {
                    field: 'operatingCashflowId100',
                    header: 'Operating Cashflow',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'operatingCashflowId100'),
                },
                {
                    field: 'operatingCashflowRatioId101',
                    header: 'Operating Cashflow Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'operatingCashflowRatioId101'),
                },
                {
                    field: 'pcfRatioId103',
                    header: 'P/CF Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pcfRatioId103'),
                },
                {
                    field: 'pfcfRatioId105',
                    header: 'P/FCF Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pfcfRatioId105'),
                },
                {
                    field: 'psRatioId106',
                    header: 'P/S Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'psRatioId106'),
                },
                {
                    field: 'pegRatioYear5Id108',
                    header: 'PEG Ratio Using Avg EPS Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear5Id108'),
                },
                {
                    field: 'pegRatioYear10Id109',
                    header: 'PEG Ratio Using Avg EPS Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear10Id109'),
                },
                {
                    field: 'pegRatioYear15Id110',
                    header: 'PEG Ratio Using Avg EPS Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear15Id110'),
                },
                {
                    field: 'pegRatioYear20Id111',
                    header: 'PEG Ratio Using Avg EPS Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear20Id111'),
                },
                {
                    field: 'diffGrahamPriceSharePriceId112',
                    header: '% diff Graham Price vs Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffGrahamPriceSharePriceId112'),
                },
                {
                    field: 'sharesOwnedInstitutionsId113',
                    header: '% Owned by Institutions',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'sharesOwnedInstitutionsId113'),
                },
                {
                    field: 'piotroskiFscoreId114',
                    header: 'Piotroski F-Score',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'piotroskiFscoreId114'),
                },
                {
                    field: 'profitMarginId115',
                    header: 'Total Operating Profit Margin',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'profitMarginId115'),
                },
                {
                    field: 'quickRatioId116',
                    header: 'Quick Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'quickRatioId116'),
                },
                {
                    field: 'recentDividendPaymentId117',
                    header: 'Recent Div Payment',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'recentDividendPaymentId117'),
                },
                {
                    field: 'roaTtmId118',
                    header: 'ROA TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'roaTtmId118'),
                },
                {
                    field: 'rocTtmId119',
                    header: 'ROC TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'rocTtmId119'),
                },
                {
                    field: 'roeTtmId120',
                    header: 'ROE TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'roeTtmId120'),
                },
                {
                    field: 'sectorId121',
                    header: 'Sector',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'sectorId121'),
                },
                {
                    field: 'sharePriceDateId124',
                    header: 'Share Date & Time',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'sharePriceDateId124'),
                },
                {
                    field: 'totalDebtVsEquityRatioId130',
                    header: 'Total Debt/Equity Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'totalDebtVsEquityRatioId130'),
                },
                {
                    field: 'totalStockholderEquityId131',
                    header: 'Total Stockholder Equity',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'totalStockholderEquityId131'),
                },
                {
                    field: 'websiteId136',
                    header: 'Website',
                    style: 'max-width: 400px; min-width: 400px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'websiteId136'),
                },
            ],
            columnConfigCompact: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear15Id127',
                    header: 'SI Criteria out of 10 (15yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear15Id127'),
                },
                {
                    field: 'siCriteriaYear10Id126',
                    header: 'SI Criteria out of 10 (10yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear10Id126'),
                },
                {
                    field: 'siCriteriaYear5Id125',
                    header: 'SI Criteria out of 10 (5yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear5Id125'),
                },
            ],
            columnConfigCompactLite: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                }
            ],
            columnConfigComplete: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear15Id127',
                    header: 'SI Criteria out of 10 (15yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear15Id127'),
                },
                {
                    field: 'siCriteriaYear10Id126',
                    header: 'SI Criteria out of 10 (10yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear10Id126'),
                },
                {
                    field: 'siCriteriaYear5Id125',
                    header: 'SI Criteria out of 10 (5yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear5Id125'),
                },
                {
                    field: 'averageEpsGrowthYear20Id018',
                    header: 'R5a – Avg EPS Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear20Id018'),
                },
                {
                    field: 'averageEpsGrowthYear15Id017',
                    header: 'R5a – Avg EPS Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear15Id017'),
                },
                {
                    field: 'averageEpsGrowthYear10Id016',
                    header: 'R5a – Avg EPS Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear10Id016'),
                },
                {
                    field: 'averageEpsGrowthYear5Id015',
                    header: 'R5a – Avg EPS Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear5Id015'),
                },
                {
                    field: 'epsIncreasesYear20Id097',
                    header: 'R5b – EPS Increases in 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear20Id097'),
                },
                {
                    field: 'epsIncreasesYear15Id096',
                    header: 'R5b – EPS Increases in 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear15Id096'),
                },
                {
                    field: 'epsIncreasesYear10Id095',
                    header: 'R5b – EPS Increases in 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear10Id095'),
                },
                {
                    field: 'epsIncreasesYear5Id094',
                    header: 'R5b – EPS Increases in 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear5Id094'),
                },
                {
                    field: 'adgYear20Id009',
                    header: 'R6 – Avg Div Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'adgYear20Id009'),
                },
                {
                    field: 'adgYear15Id008',
                    header: 'R6 – Avg Div Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'adgYear15Id008'),
                },
                {
                    field: 'adgYear10Id007',
                    header: 'R6 – Avg Div Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'adgYear10Id007'),
                },
                {
                    field: 'adgYear5Id006',
                    header: 'R6 – Avg Div Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'adgYear5Id006'),
                },
                {
                    field: 'payoutRatioId107',
                    header: 'R7 – Payout Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'payoutRatioId107'),
                },
                {
                    field: 'longtermDebtEquityRatioId084',
                    header: 'R8 - LT Debt/Equity',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtEquityRatioId084'),
                },
                {
                    field: 'afdPreviousId005',
                    header: 'R9 - Fwd Dividend vs Prev Year',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'afdPreviousId005'),
                },
                {
                    field: 'shareBuybackId122',
                    header: 'R10 – Share Buyback?',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-buyback',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'shareBuybackId122'),
                },
                {
                    field: 'peRatioId104',
                    header: 'R11a – P/E Ratio TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'peRatioId104'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear20Id135',
                    header: 'R11b – Under/Over Valued Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear20Id135'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear15Id134',
                    header: 'R11b – Under/Over Valued Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear15Id134'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear10Id133',
                    header: 'R11b – Under/Over Valued Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear10Id133'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear5Id132',
                    header: 'R11b – Under/Over Valued Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear5Id132'),
                },
                {
                    field: 'pbRatioId102',
                    header: 'R11c – P/B Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pbRatioId102'),
                },
                {
                    field: 'yearsDividendIncreasesId047',
                    header: 'Consecutive Yrs Div Increases',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'yearsDividendIncreasesId047'),
                }
            ]
        }
    },
    computed: {
        filteredColumns() {
            console.log("[Overview][computed] this.columnConfig.filter(column => column.condition()) = ",
                this.columnConfig.filter(column => column.condition()));
            return this.columnConfig.filter(column => column.condition());
        },
        canAddWatchlistItem() {
            return (
                this.selectedWatchlistExchange &&
                this.selectedWatchlistCode
            );
        },
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        processSetGoals() {
            console.log("[MenuConfiguration][processSetGoals] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siSetGoals');
        },
        processWatchlist() {
            console.log("[MenuConfiguration][processWatchlist] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siWatchlist');
        },
        callSetGoals() {
            this.activeTab = 3;
        },
        callOverviewWatchList() {
            this.activeTab = 4;
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        async onTimePeriodChange() {
            this.loading = true;

            try {
                console.log("[Overview][onTimePeriodChange] this.selectedTimePeriod = ", this.selectedTimePeriod);
                // console.log("[Overview][onTimePeriodChange] this.stock.undervaluedVsOvervaluedStatusYear5Id132 = ",
                //     this.stock.undervaluedVsOvervaluedStatusYear5Id132);

                this.selectedFormat = "Compact";

                if (this.selectedExchange === "JSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedJseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedJseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedJseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
                    }

                } else if (this.selectedExchange === "LSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedLseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedLseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedLseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
                    }

                } else {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedNyseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedNyseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedNyseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
                    }

                }

                this.stockData = this.stockData
                    .sort((a, b) => b.yearsDividendIncreasesId047 - a.yearsDividendIncreasesId047);

                if (this.selectedFormat === "Compact") {
                    if (this.selectedTimePeriod === "5") {
                        this.selectedColumns = this.columnConfigCompact;

                    } else if (this.selectedTimePeriod === "10") {

                        this.selectedColumns = this.columnConfigCompact;

                    } else if (this.selectedTimePeriod === "15") {

                        this.selectedColumns = this.columnConfigCompact;

                    } else {
                        this.selectedColumns = this.columnConfigCompact;

                    }
                } else {

                    if (this.selectedTimePeriod === "5") {
                        this.selectedColumns = this.columnConfigComplete;

                    } else if (this.selectedTimePeriod === "10") {
                        this.selectedColumns = this.columnConfigComplete;

                    } else if (this.selectedTimePeriod === "15") {
                        this.selectedColumns = this.columnConfigComplete;

                    } else {
                        this.selectedColumns = this.columnConfigComplete;

                    }

                }

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }

        },
        async onFormatChange() {
            console.log("[Plan][onFilterChange] this.selectedFormat = ", this.selectedFormat);

            if (this.selectedFormat === "Compact") {
                this.selectedColumns = this.columnConfig.filter(config =>
                    this.columnConfigCompact.some(compact => compact.field === config.field)
                );

            } else {

                this.selectedColumns = this.columnConfig.filter(config =>
                    this.columnConfigComplete.some(compact => compact.field === config.field)
                );

            }
        },
        handleDTClick() {
            this.activeTab = 5;
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'codeId129': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
                },
                'companyNameId046': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        // searchCodes(event) {
        //     console.log("[Plan][searchCodes] event.query = ", event.query);
        //     console.log("[Plan][searchCodes] this.selectedWatchlistExchange = ", this.selectedWatchlistExchange);
        //
        //     StockService.searchStocksForExchangeByName(this.selectedWatchlistExchange, event.query.toLowerCase())
        //         .then(data => {
        //             console.log("[Plan][searchCodes] Getting codes for exchange = ", this.selectedWatchlistExchange);
        //             this.filteredCodes = data.data;
        //             console.log("[Plan][searchCodes] Got codes = ", data.data);
        //         })
        //         .catch(e => {
        //             console.log("[Plan][searchCodes] Could not get codes for exchange = ", this.selectedWatchlistExchange);
        //             console.log("[Plan][searchCodes] Error = ", e);
        //         });
        //
        // },
        searchCodes(event) {
            console.log("[Plan][searchCodes] event.query = ", event.query);
            console.log("[Plan][searchCodes] this.selectedWatchlistExchange = ", this.selectedWatchlistExchange);
            console.log("[Plan][searchCodes] this.selectedWatchlistCode = ", this.selectedWatchlistCode);

            StockService.searchStocksForExchangeByName(this.selectedWatchlistExchange, event.query.toLowerCase())
                .then(data => {
                    const searchResults = data.data;

                    // Get a list of codes that are already in the watchlist for the selected exchange
                    const watchlistCodes = this.watchList
                        .filter(item => item.exchange === this.selectedWatchlistExchange)
                        .map(item => item.code);

                    // Filter the search results to exclude any codes found in the watchlist
                    const filteredResults = searchResults.filter(stock => {
                        // Check if the stock's code is NOT in the watchlistCodes array
                        return !watchlistCodes.includes(stock.code);
                    });

                    this.filteredCodes = filteredResults.map(stock => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code
                    }));

                    console.log("[Plan][searchCodes] Got watchlist codes = ", this.filteredCodes);

                    // this.filteredCodes = data.data.map(stock => ({
                    //     label: `${stock.name} (${stock.code})`,
                    //     value: stock.code // or the entire stock object, depending on your needs
                    // }));
                    //
                    // console.log("[Plan][searchCodes] Got client data = ", data.data);
                })
                .catch(e => {
                    console.log("[Plan][searchCodes] Error = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                });
        },
        async onExchangeChange() {
            this.loading = true;

            try {
                this.selectedFormat = "Compact";
                this.selectedStandardFilter = "topRanked";
                this.selectedTimePeriod = "20";

                const [stockDataInfo] = await Promise.all([
                    StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S')
                ]);

                this.stockData = stockDataInfo.data;
                this.originalStockData = stockDataInfo.data;

                this.getDividendTrap();

                console.log("[Plan][onExchangeChange] this.selectedExchange = ", this.selectedExchange);
                console.log("[Plan][onExchangeChange] this.stockData = ", this.stockData);

                // Normalize exchange for consistent comparison
                const normalizedExchange = this.selectedExchange.trim().toUpperCase();

                console.log("[Plan][onExchangeChange] normalizedExchange = ", normalizedExchange);

                // Filter stock data based on watchlist and exchange
                this.stockData = this.stockData.filter(stock =>
                    // Match stock codes with watchlist items and their exchange value
                    this.watchList.some(item =>
                        stock.codeId129 === item.code &&
                        stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                        item.exchange?.trim().toUpperCase() === normalizedExchange
                    )
                );

                // let criteriaString = "";
                //
                // this.watchList.forEach((item, index, array) => {
                //     if (index === array.length - 1) {
                //         console.log("This is the last element.");
                //         criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' ";
                //     } else {
                //         criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' || ";
                //     }
                // });
                //
                // try {
                //     console.log("[Debug] criteriaString:", criteriaString);
                //     const dynamicFilter = new Function('stock', `return ${criteriaString};`);
                //     this.stockData = this.stockData.filter(stock => dynamicFilter(stock));
                //     console.log("Filtered Stock Data:", this.stockData);
                // } catch (error) {
                //     console.error("Error in dynamic filter function:", error);
                // }

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async onStockDataTimePeriodChange() {
            this.loading = true;

            try {
                console.log("[Overview][onStockDataTimePeriodChange] Got here.");

                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -25
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

                const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";
                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";
                }

                console.log("[Overview][onStockDataStockHistoryOptionChange] this.selectedStockDataStockHistoryOption = ", this.selectedStockDataStockHistoryOption);
                console.log("[Overview][onStockDataStockHistoryOptionChange] selectedOption = ", selectedOption);

                if (selectedOption) {
                    // Set up lineData with the appropriate label and data based on the selected option code
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                                // data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }

        },
        async onStockDataStockHistoryOptionChange() {
            this.loading = true;

            try {
                console.log("[Overview][onStockDataStockHistoryOptionChange] Got here.");

                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -25
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

                const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";
                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";
                }

                console.log("[Overview][onStockDataStockHistoryOptionChange] this.selectedStockDataStockHistoryOption = ", this.selectedStockDataStockHistoryOption);
                console.log("[Overview][onStockDataStockHistoryOptionChange] selectedOption = ", selectedOption);

                if (selectedOption) {
                    // Set up lineData with the appropriate label and data based on the selected option code
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                                // data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        onToggleColumns(value) {
            console.log("[Plan][onToggleColumns] value = ", value);
            this.selectedColumns = [...value]; // Ensure reactivity
            this.selectedFormat = "Complete";
            console.log("[Plan][onToggleColumns] this.selectedColumns = ", this.selectedColumns);
            console.log("[Plan][onToggleColumns] this.columnConfig = ", this.columnConfig);
            this.activeTab = 4;
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        formatNumeric(value) {
            if (value) {
                return numeral(value).format('0,0'); // Returns a formatted string with thousand separators
            } else {
                return '0'; // Ensure consistency by returning a string
            }
        },
        formatString(value) {
            if (value) {
                const formattedValue = String(value).substring(0, 50);
                return formattedValue;
            } else {
                return '';
            }
        },
        getDividendTrap() {
            let averageDividendYieldTotal = 0;

            let combinedList = [];
            let topRankedList = [];
            let runnersUpList = [];

            if (this.selectedExchange === "JSE") {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpJseCriteria);
            } else if (this.selectedExchange === "LSE") {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
            } else {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
            }

            combinedList = [...topRankedList, ...runnersUpList];

            let totalDividendYield = combinedList.reduce((total, stock) => {
                return total + (stock.currentDividendYieldId050 || 0);
            }, 0);

            if (combinedList.length > 0) {
                averageDividendYieldTotal = totalDividendYield / combinedList.length;
            }

            this.averageDividendYield = averageDividendYieldTotal;
            this.maxDividendYield = this.averageDividendYield * 2.5;

        },
        async onCompanyCodeClick(inputStockData) {
            this.loading = true;

            try {
                this.activeTab = 6;
                this.specificStockData = inputStockData;
                this.specificStockDataArray = [inputStockData];

                try {
                    const [stockHistoryInfo] = await Promise.all([
                        StockHistoryService.getStockHistory(this.selectedExchange, inputStockData.codeId129)
                    ]);

                    this.stockHistory = stockHistoryInfo.data;
                    console.log("[Overview][mounted] this.stockHistory = ", this.stockHistory);

                    const sliceSize = -25;
                    const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);
                    this.stockHistory = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;


                } catch (e) {
                    console.error("[Overview][onCompanyCodeClick] Error fetching stock history data = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }

                const sliceSize = -20;

                const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

                const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                this.lineData = {
                    labels: recentYears.map(item => item.year),
                    datasets: [
                        {
                            label: selectedLabel, // Use the name from the selected option
                            data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                            fill: false,
                            borderColor: '#42A5F5',
                            tension: 0.4
                        }
                    ]
                };

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Months'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                console.log("this.specificStockData = ", this.specificStockData);
                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async callWatchlist() {
            this.activeTab = 4;

            this.loading = true;

            if (this.exchanges.length > 0) {
                this.selectedExchange = this.exchanges[0].code;
            }

            console.log("[Plan][callWatchlist] this.selectedExchange = ", this.selectedExchange);

            const [watchlistInfo] = await Promise.all([
                WatchlistService.getUserWatchlists(this.userStore.user.id)
            ]);

            this.watchList = watchlistInfo.data;
            const normalizedExchange = this.selectedExchange.trim().toUpperCase();

            console.log("[Plan][callWatchlist] normalizedExchange = ", normalizedExchange);

            this.stockData = this.stockData.filter(stock =>
                this.watchList.some(item =>
                    stock.codeId129 === item.code &&
                    stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                    item.exchange?.trim().toUpperCase() === normalizedExchange
                )
            );

            this.loading = false;
        },
        // async callWatchlist() {
        //     this.activeTab = 4;
        //     this.loading = true;
        //
        //     console.log("[Plan][callWatchlist] this.selectedExchange = ", this.selectedExchange);
        //
        //     const [stockDataInfo, watchlistInfo] = await Promise.all([
        //         StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
        //         WatchlistService.getUserWatchlists(this.userStore.user.id)
        //     ]);
        //
        //     this.stockData = stockDataInfo.data;
        //     this.originalStockData = stockDataInfo.data;
        //     this.watchList = watchlistInfo.data;
        //
        //     console.log("[Plan][callWatchlist] this.originalStockData = ", this.originalStockData);
        //
        //     let criteriaString = "";
        //
        //     this.watchList.forEach((item, index, array) => {
        //         if (index === array.length - 1) {
        //             console.log("This is the last element.");
        //             criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' ";
        //         } else {
        //             criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' || ";
        //         }
        //     });
        //
        //     criteriaString = criteriaString + "&& (stock.exchangeId073 === '" + this.selectedExchange + "') ";
        //
        //     try {
        //         console.log("[Plan][callWatchlist] criteriaString = ", criteriaString);
        //
        //         const dynamicFilter = new Function('stock', `return ${criteriaString};`);
        //         this.stockData = this.stockData.filter(stock => dynamicFilter(stock));
        //
        //         console.log("[Plan][callWatchlist] this.stockData (filtered) = ", this.stockData);
        //     } catch (error) {
        //         console.error("Error in dynamic filter function:", error);
        //     }
        //
        //     this.loading = false;
        //
        // },
        callWatchlistAdd() {
            this.activeTab = 7;
            this.selectedWatchlistCode = "";

            if (this.exchanges && this.exchanges.length > 0) {
                this.selectedWatchlistExchange = this.exchanges[0].code;
            }
        },
        async callWatchlistDelete() {
            this.activeTab = 8;

            const [watchlistInfo] = await Promise.all([
                WatchlistService.getUserWatchlists(this.userStore.user.id)
            ]);

            this.watchList = watchlistInfo.data;
        },
        callDeleteWatchlistItem(data) {
            this.existingWatchlistItem = data;
            this.activeTab = 4;
            this.confirmationResponse = "N";
        },
        async savePlanConfiguration() {
            this.submitted = true;
            this.loading = true;

            if (this.selectedWatchlistExchange) {

                try {
                    var newDataDto = {
                        siFreedomGoal: this.userConfiguration.siFreedomGoal,
                        siFreedomYear: this.userConfiguration.siFreedomYear,
                        siPlanCurrency: this.userConfiguration.siPlanCurrency
                    };

                    console.log('[Plan][savePlanConfiguration] this.userStore.user.id = ', this.userStore.user.id);
                    console.log('[Plan][savePlanConfiguration] newDataDto = ', newDataDto);

                    const response = await UserService.updateUserConfig(this.userStore.user.id, newDataDto);

                    try {
                        const [userConfigData] = await Promise.all([
                            UserService.getUserConfig(this.userStore.user.id)
                        ]);

                        this.userConfiguration = userConfigData.data;
                        console.log("[Plan][savePlanConfiguration] userConfigData.data = ", userConfigData.data);
                    } catch (e) {
                        console.error("[Plan][savePlanConfiguration] Could not find user config for user = ", this.userStore.user.id);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;

                    }

                    console.log('[Plan][savePlanConfiguration] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated plan information',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Plan][savePlanConfiguration] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update plan information. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 3;
            this.submitted = false;
            this.loading = true;

        },
        async saveWatchlistItem() {
            this.submitted = true;
            this.loading = true;

            console.log('[Plan][saveWatchlistItem] this.selectedWatchlistExchange = ', this.selectedWatchlistExchange);
            console.log('[Plan][saveWatchlistItem] this.selectedWatchlistCode = ', this.selectedWatchlistCode);
            console.log('[Plan][saveWatchlistItem] this.selectedWatchlistCode.value = ', this.selectedWatchlistCode.value);

            if (this.selectedWatchlistExchange) {

                try {
                    var newDataDto = {
                        exchange: this.selectedWatchlistExchange,
                        code: this.selectedWatchlistCode.value
                    };

                    console.log('[Plan][saveWatchlistItem] this.userStore.user.id = ', this.userStore.user.id);
                    console.log('[Plan][saveWatchlistItem] newDataDto = ', newDataDto);

                    const response = await WatchlistService.createWatchlist(this.userStore.user.id, newDataDto);

                    console.log('[Plan][saveWatchlistItem] Response = ', response);

                    const [stockDataInfo, watchlistInfo] = await Promise.all([
                        StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
                        WatchlistService.getUserWatchlists(this.userStore.user.id)
                    ]);

                    this.stockData = stockDataInfo.data;
                    this.originalStockData = stockDataInfo.data;
                    this.watchList = watchlistInfo.data;

                    console.log("[Plan][saveWatchlistItem] this.originalStockData = ", this.originalStockData);

                    const normalizedExchange = this.selectedExchange.trim().toUpperCase();

                    console.log("[Plan][saveWatchlistItem] normalizedExchange = ", normalizedExchange);

                    // Filter stock data based on watchlist and exchange
                    this.stockData = this.stockData.filter(stock =>
                        // Match stock codes with watchlist items and their exchange value
                        this.watchList.some(item =>
                            stock.codeId129 === item.code &&
                            stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                            item.exchange?.trim().toUpperCase() === normalizedExchange
                        )
                    );

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created watchlist item',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Plan][saveWatchlistItem] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create watchlist item. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;

                }
            }

            this.activeTab = 4;
            this.submitted = false;
            this.loading = false;

        },
        async deleteWatchlistItem() {
            this.submitted = true;
            this.loading = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.existingWatchlistItem.id) {

                    try {
                        const response = await WatchlistService.deleteWatchlist(this.existingWatchlistItem.id);
                        console.log('[Plan][deleteWatchlistItem] Response = ', response);

                        const [stockDataInfo, watchlistInfo] = await Promise.all([
                            StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
                            WatchlistService.getUserWatchlists(this.userStore.user.id)
                        ]);

                        this.stockData = stockDataInfo.data;
                        this.originalStockData = stockDataInfo.data;
                        this.watchList = watchlistInfo.data;

                        console.log("[Plan][deleteWatchlistItem] this.originalStockData = ", this.originalStockData);

                        const normalizedExchange = this.selectedExchange.trim().toUpperCase();

                        console.log("[Plan][deleteWatchlistItem] normalizedExchange = ", normalizedExchange);

                        // Filter stock data based on watchlist and exchange
                        this.stockData = this.stockData.filter(stock =>
                            // Match stock codes with watchlist items and their exchange value
                            this.watchList.some(item =>
                                stock.codeId129 === item.code &&
                                stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                                item.exchange?.trim().toUpperCase() === normalizedExchange
                            )
                        );

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted watchlist item',
                            life: 3000
                        });
                    } catch (e) {
                        console.error('[Plan][deleteWatchlistItem] Error:', e);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete watchlist item. Please try again.',
                            life: 3000
                        });

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;

                    }
                }
            }

            this.activeTab = 3;
            this.submitted = false;
            this.loading = false;

        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}

.highlight {
    background-color: #7cd9d1; /* Example: light red */
    color: black; /* Text color */
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-DT {
        background: #E5C7BCFF;
        color: #BE5306FF;
    }
}
</style>
